import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Journal = () => {
  const [journalList, setJournalList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 9;
  const navigate = useNavigate(); // 추가

  useEffect(() => {
    const fetchJournal = async () => {
      try {
        const response = await axios.get('http://plassion.co.kr:8444/api/get/board_list', {
          params: {
            cate: 'journal',
            page: currentPage,
            pageSize: itemsPerPage,
          },
        });
        setJournalList(response.data.data);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error('Error fetching journal data:', error);
      }
    };
    fetchJournal();
  }, [currentPage]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // 페이지 최상위로 스크롤
  };

  const handleFirstPage = () => {
    paginate(1);
  };

  const handleLastPage = () => {
    paginate(totalPages);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      paginate(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      paginate(currentPage - 1);
    }
  };

  const handleDetailClick = (idx) => {
    navigate(`/board/journal/${idx}`); // 상세 페이지로 이동
  };

  return (
    <div className="journal-wrap">
      <div className="journal-intro-title">
        플레이션의 회사 런칭 소식,
        <br />
        빠르게 변화하는 디지털 세계 속에서
        <br /> AI와 디지털 기술을 바탕으로 나아가는 플레이션입니다.
      </div>
      <div className="journal-grid">
        {journalList.map((journal, index) => (
          <div className="journal-box" key={index}>
            <div className="image-container">
              <img src={`http://plassion.co.kr:8444/uploads/${journal.img1}`} alt={journal.title} />
              <div className="journal-hover" onClick={() => handleDetailClick(journal.idx)}>
                <p>상세보기</p>
              </div>
            </div>
            <div className="journal-content">
              <h3>{journal.title}</h3>
              <p>{journal.content.replace(/<[^>]+>/g, '')}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="pagination">
        <button onClick={handleFirstPage} disabled={currentPage === 1}>
          {'<<'}
        </button>
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          {'<'}
        </button>
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} onClick={() => paginate(i + 1)} className={currentPage === i + 1 ? 'active' : ''}>
            {i + 1}
          </button>
        ))}
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          {'>'}
        </button>
        <button onClick={handleLastPage} disabled={currentPage === totalPages}>
          {'>>'}
        </button>
      </div>
    </div>
  );
};

export default Journal;
